import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { CheckCircle2, Wrench, Ban } from "lucide-react";

const STATUS = [
  { value: "available", label: "Available", Icon: CheckCircle2, cls: "text-emerald-500" },
  { value: "maintenance", label: "Maintenance", Icon: Wrench, cls: "text-amber-500" },
  { value: "disabled", label: "Disabled", Icon: Ban, cls: "text-rose-500" },
];

export default function AdminLabs() {
  const [labs, setLabs] = useState([]);
  const load = async () => { const { data } = await api.get("/admin/portal/labs"); setLabs(data.labs || []); };
  useEffect(() => { load(); }, []);

  const setStatus = async (lab_id, status) => {
    await api.post(`/admin/portal/labs/${lab_id}`, { status });
    setLabs((ls) => ls.map((l) => l.id === lab_id ? { ...l, availability: status } : l));
    toast.success(`${lab_id} → ${status}`);
  };

  return (
    <div className="p-8 max-w-4xl" data-testid="admin-labs-page">
      <h1 className="font-display text-2xl font-extrabold tracking-tight">Lab Management</h1>
      <p className="text-muted-foreground mt-1 text-sm">Control which training labs students can launch. Disabled labs are hidden from students; maintenance labs are visible but not launchable.</p>
      <div className="mt-6 rounded-xl border border-border bg-card divide-y divide-border">
        {labs.map((lab) => (
          <div key={lab.id} className="flex items-center gap-4 px-5 py-4" data-testid={`admin-lab-${lab.id}`}>
            <span className="h-2.5 w-2.5 rounded-sm shrink-0" style={{ background: lab.accent }} />
            <div className="min-w-0 flex-1">
              <div className="font-semibold">{lab.name}</div>
              <div className="text-xs text-muted-foreground">{lab.category} · {lab.route}</div>
            </div>
            <Select value={lab.availability} onValueChange={(v) => setStatus(lab.id, v)}>
              <SelectTrigger className="w-44" data-testid={`admin-lab-status-${lab.id}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                {STATUS.map((s) => <SelectItem key={s.value} value={s.value}><span className={`inline-flex items-center gap-2 ${s.cls}`}><s.Icon className="h-3.5 w-3.5" /> {s.label}</span></SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        ))}
        {labs.length === 0 && <div className="px-5 py-10 text-center text-sm text-muted-foreground">Loading labs…</div>}
      </div>
    </div>
  );
}
